import { Hero3up } from "@components/hero3up";
import { NewsletterSignup } from "@components/newsletterSignup";
import { SectionHeading } from "@components/headings/section";
import { makeLpTitle } from "@utils/makeLpTitle";
import { LP_URL } from "@constants/lpUrl";
import { NextHead } from "@components/nextHead";

export default function Kids() {
  const metaTitle = "Kids";
  const metaDescription =
    "Discover a whole new world of adventures with Lonely Planet Kids. Featuring kids books about the globe, activities, videos, family travel posts and more.";
  const canonicalUrl = `${LP_URL}/kids`;

  return (
    <div>
      <NextHead>
        <title>{makeLpTitle(metaTitle)}</title>
        <link key="canonical" rel="canonical" href={canonicalUrl} />
        <meta key="title" name="title" content={makeLpTitle(metaTitle)} />
        <meta key="description" name="description" content={metaDescription} />
        <meta
          key="og:title"
          property="og:title"
          content={makeLpTitle(metaTitle)}
        />
        <meta key="og:url" property="og:url" content={canonicalUrl} />
        <meta
          key="og:description"
          property="og:description"
          content={metaDescription}
        />
        <meta
          key="twitter:title"
          name="twitter:title"
          content={makeLpTitle(metaTitle)}
        />
        <meta
          key="twitter:description"
          name="twitter:description"
          content={metaDescription}
        />
      </NextHead>

      <Hero3up
        title="Lonely Planet Kids"
        data={[
          {
            title: "Discover books to inspire young explorers",
            image:
              "https://lp-cms-production.imgix.net/2022-01/LPK-homepage-kids.png",
            href: "https://shop.lonelyplanet.com/pages/lonely-planet-kids",
          },
          {
            title: "Take a journey through every country in the world",
            image:
              "https://lp-cms-production.imgix.net/2022-01/LPK-homepage-The-Travel-Book-2.png",
            href: "https://shop.lonelyplanet.com/products/the-travel-book-lonely-planet-kids-us-version",
          },
          {
            title: "Learn a new lingo with First Words!",
            image: "https://lp-cms-production.imgix.net/2019-06/Homepage3.jpg",
            href: `${LP_URL}/kids/first-words`,
          },
        ]}
      />

      <div className="container max-w-3xl py-10 text-center">
        <SectionHeading className="my-4">Our Story</SectionHeading>
        <p>
          Lonely Planet began in 1973 with an epic overland journey from London
          to Australia, and the publication of Across Asia on the Cheap shortly
          after. Today, we’re one of the world’s leading travel media companies,
          and want to share our love for travel and the planet with the next
          generation of explorers.
        </p>
        <p className="my-10">That’s why we created Lonely Planet Kids.</p>
        <p>
          Our first release was The Travel Book in 2011. And since then, we’ve
          published books on everything from dinosaurs and space travel to
          secret city walks and woolly mammoths. Our mission is to inspire
          children and get them excited about the amazing world around them – to
          help make every day an adventure
        </p>
      </div>

      <div className="bg-blue py-8 lg:p-16">
        <div className="container">
          <div className="bg-white xl:flex items-center p-8 lg:p-16 rounded">
            <div className="xl:w-3/5 xl:inline-block">
              <h3 className="text-xl xl:text-2xl font-bold text-blue">
                Subscribe & Get 20% off
              </h3>
              <p className="pr-0 md:pr-5 mt-4 text-black md:text-black-400 xl:w-3/4">
                Join our newsletter and discover new destinations to inspire the
                traveler within. Plus, get 20% off at our online shop. Every
                week you’ll receive expert advice, tips, exclusive offers, and
                much more.
              </p>
            </div>
            <NewsletterSignup
              className="xl:w-2/5 xl:inline-block"
              inlineForm
              source="homepage-guidebook-newsletter-signup"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export async function getStaticProps() {
  return {
    props: {
      children: null,
    },
  };
}
